<template>
  <div class="new-life">
    <my-scroll class="scroll">
      <div class="scroll-content">
        <header>ຄໍາອະທິບາຍການຍົກເລີກບັນຊີຜູ້ໃຊ້ GoLaos</header>
        <h3>1. ວິທີການຍົກເລີກບັນຊີ</h3>
        <div class="letter">
          <span>ຜູ້ໃຊ້ສາມາດດໍາເນີນການຍົກເລີກບັນຊີໄດ້ດ້ວຍຕົນເອງພາຍໃນແອັບ GoLaos ຕາມຂັ້ນຕອນດັ່ງນີ້:</span><br />
          <span>ເປີດແອັບ GoLaos → ຂອງຂ້ອຍ → ການຕັ້ງຄ່າ → ຍົກເລີກບັນຊີ</span>
        </div>
        <h3>2. ການມີຜົນຂອງການຍົກເລີກບັນຊີ</h3>
        <div class="letter1 letter">
          <span>
            ຫຼັງຈາກຜູ້ໃຊ້ຢືນຢັນການຍົກເລີກບັນຊີແລ້ວ, ການດໍາເນີນການຈະມີຜົນໃນທັນທີ ຫຼື ພາຍໃນໄລຍະເວລາທີ່ເໝາະສົມ. ຫຼັງຈາກບັນຊີຖືກຍົກເລີກແລ້ວ ຈະບໍ່ສາມາດກູ້ຄືນໄດ້ ກະລຸນາດໍາເນີນການດ້ວຍຄວາມລະມັດລະວັງ
          </span>
        </div>
        <h3>3. ການລຶບ ແລະ ການເກັບຮັກສາຂໍ້ມູນ</h3>
        <div class="letter letter1">
          <span>
            ຫຼັງຈາກຍົກເລີກບັນຊີແລ້ວ ພວກເຮົາຈະລຶບຂໍ້ມູນສ່ວນບຸກຄົນທີ່ກ່ຽວຂ້ອງກັບບັນຊີນັ້ນ ລວມທັງແຕ່ບໍ່ຈໍາກັດຢູ່ທີ່:
          </span>
          <ul>
            <li>ຂໍ້ມູນບັນຊີ</li>
            <li>ຂໍ້ມູນສ່ວນຕົວ</li>
            <li>ຂໍ້ມູນການເຂົ້າລະບົບ</li>
          </ul>
        </div>
        <div class="letter letter1">
          <span>
            ຢ່າງໃດກໍຕາມ ຕາມກົດໝາຍ ແລະ ຂໍ້ກໍານົດທາງການກຳກັບດູແລ ຂໍ້ມູນບາງປະເພດ (ເຊັ່ນ ບັນທຶກທຸລະກໍາ ຫຼື ຂໍ້ມູນທາງການເງິນ) ອາດຈະຖືກເກັບຮັກສາໄວ້ໃນໄລຍະເວລາທີ່ເໝາະສົມ ເພື່ອຈຸດປະສົງດ້ານການປະຕິບັດຕາມກົດໝາຍ ການກວດສອບ ຫຼື ການແກ້ໄຂຂໍ້ພິພາດ ແລະ ຈະຖືກລຶບອອກຢ່າງປອດໄພຫຼັງຈາກພົ້ນໄລຍະເວລານັ້ນ
          </span>
        </div>
        <h3>4. ຜົນກະທົບຫຼັງຈາກຍົກເລີກບັນຊີ</h3>
        <div class="letter1 letter">
          <span>
            ຫຼັງຈາກຍົກເລີກບັນຊີແລ້ວ ຜູ້ໃຊ້ຈະບໍ່ສາມາດເຂົ້າລະບົບດ້ວຍບັນຊີເກົ່າໄດ້ ແລະ ບໍ່ສາມາດເຂົ້າເຖິງ ຫຼື ກູ້ຄືນຂໍ້ມູນໃດໆທີ່ເຄີຍມີ
          </span>
        </div>
      </div>
    </my-scroll>
  </div>
</template>

<script>
import MyScroll from "../../components/MyScroll";
export default {
  name: "newLifeZh",
  components: {
    MyScroll,
  },
  // eslint-disable-next-line space-before-function-paren
  setup() {
    // const { ctx } = getCurrentInstance()
    // console.log(ctx.$root.$route.query.lang)
    return {
      txt1: "",
    };
  },
};
</script>

<style scoped lang="scss">
@mixin flex-box-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.new-life {
  width: 100%;
  .scroll {
    width: 100%;
    height: 100%;
    padding: 0px 16px;
    position: absolute;
    touch-action: none;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      width: 0px;
    }
    header {
      width: 100%;
      margin-top: 25px;
      margin-bottom: 35px;
      height: 28px;
      padding: 0px 16px;
      overflow: hidden;
      opacity: 1;
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      @include flex-box-center;
    }
    .scroll-content {
      position: absolute;
      top: 0px;
      padding: 0px 16px;
      left: 0px;
      h3 {
        padding: 13px 0px 0px;
        margin-bottom: 12px;
        // height: 25px;
        opacity: 1;
        font-size: 15px;
        font-weight: bold;
        text-align: left;
        color: #333333;
        // line-height: 40px;
      }
      span {
        // font-weight: 600;
      }
      .letter {
        text-align: left;
        opacity: 1;
        font-size: 15px;
        font-weight: 400;
        line-height: 25px;
        white-space: normal;
        color: #333333;
      }
      .letter1 {
        margin-top: 12px;
      }
    }
  }
}
</style>
